import GeneralSectionComponent from "../generalSectionComponent";
import { IDENTIFICATION_DOCUMENTS_COLUMNS } from "../../../../components/GeneralComponents/SearchTable/TablesColumns";
import { getIdentificationDocument } from "../../../../redux/directoryMaintenance/indentificationDocumentsReducer/actionIdentificationDocuments";
import IdentificationDocumentsModal from "./identificationDocumentsModal/IdentificationDocumentsModal";

function IdentificationDocuments() {
  return (
    <GeneralSectionComponent
      title={"Типы документов, удостоверяющих личность"}
      headerColumns={IDENTIFICATION_DOCUMENTS_COLUMNS}
      dataFromStateSelector={(state) =>
        state.dictionaryReducer.identificationDocuments
      }
      getAction={getIdentificationDocument}
      ModalComponent={IdentificationDocumentsModal}
    />
  );
}

export default IdentificationDocuments;
